import { useEffect, useRef, useState } from "react";

const Accordion = () => {
  // console.log(tripFaq, "tripFaq");
  let AccordianData = [
    {
      title: "What is TBD (The Best Deals)?",
      description: ` TBD is the top-rated app and a smart shopping platform that brings you the hottest deals and offers from top online stores like Amazon, Flipkart, Myntra, Ajio, and more. Along with helping you discover the great deals, TBD also lets you check the complete price history of any product. It works as an Amazon price tracker and Flipkart price tracker, Myntra price tracker, etc, so you always know the right time to shop. `,
    },
    {
      title: "How does the price graph feature work?",
      description:
        "The price graph feature works to help you find out the price fluctuations of the product you are eyeing. This feature shows the complete price history of the products from all the top online stores, including Amazon, Flipkart, Myntra, Ajio, etc. ",
    },
    {
      title: "Can I create my own deal groups?",
      description:
        "Yes, you can create your own deal group based on your preferred shopping categories and even from your desired online store. ",
    },
    {
      title: "Do I get real-time deal alerts like Telegram?",
      description:
        "Yes, you can get the real-time loot deals alerts or notifications, similar to Telegram, unless you have muted the groups you want to get updates from. ",
    },
    {
      title: " Is TBD free to use?",
      description: "Yes, TBD, the best deals app is completely free to use. ",
    },
    {
      title: "Why is TBD better than Telegram for deals?",
      description:
        " TBD is a top-rated app, better than Telegram loot deals pages, because it gives you personalized experience. You can track the price history of any product, get real-time alerts, and use it as an Amazon price tracker and Flipkart price tracker. Unlike Telegram, where deals can get lost in the crowd, TBD lets you create your personalized groups, filter by top online stores and various shopping categories. ",
    },
  ];
  const [curr, setCurr] = useState([]);
  const pannelRefs = useRef([]);

  const handleOnClick = (index) => {
    const foundIndex = curr.indexOf(index);

    let pannel = pannelRefs.current[index];
    if (foundIndex === -1) {
      setCurr([...curr, index]);

      if (pannel.style.maxHeight) {
        pannel.style.maxHeight = null;
      } else {
        pannel.style.maxHeight = pannel.scrollHeight + "px";
      }
    } else {
      setCurr(curr.filter((_, i) => i !== foundIndex));
      if (pannel.style.maxHeight) {
        pannel.style.maxHeight = null;
      } else {
        pannel.style.maxHeight = pannel.scrollHeight + "px";
      }
    }
  };

  return (
    <div className="flex flex-col gap-4 p-2">
      {AccordianData?.map((data, index) => {
        return (
          <div
            key={index}
            className="flex flex-col border rounded-[20px] h-fit py-[10px] md:py-[15px] md:px-[23px] px-[13px]"
            style={{ boxShadow: "0px 2.65px 6.625px 0px rgba(0, 0, 0, 0.10)" }}
          >
            <div
              className=" text-[15px] md:text-[24px] font-bold leading-[27px]  pt-2 bg-[#fffcf2] cursor-pointer accordion flex justify-between "
              onClick={() => handleOnClick(index)}
            >
              <div className="">{data.title}</div>
              <div
                className={`lg:size-[40px] md:size-[30px] size-[23px] select-none flex justify-center items-center
                  }`}
              >
                <div className={``}>
                  <div
                    className={`lg:size-[40px] md:size-[30px] size-[23px] flex items-center justify-center rounded-full cursor-pointer transition-all duration-500 ease-in-out bg-[#8157F1]`}
                  >
                    <div
                      className={`absolute text-white md:text-3xl text-base font-bold transition-transform duration-500 ease-in-out ${
                        curr.includes(index)
                          ? "opacity-100 scale-100 rotate-0"
                          : "opacity-0 scale-50 rotate-180"
                      }`}
                    >
                      +
                    </div>
                    <div
                      className={`absolute text-white  text-base  md:text-3xl font-bold transition-transform duration-500 ease-in-out ${
                        curr.includes(index)
                          ? "opacity-0 scale-50 -rotate-180"
                          : "opacity-100 scale-100 rotate-0"
                      }`}
                    >
                      −
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              ref={(el) => (pannelRefs.current[index] = el)}
              className={`max-h-0 overflow-hidden duration-200 ease-out `}
            >
              <div className="py-2 text-[12px] md:text-[17.438px] font-normal text-black">
                {data.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default Accordion;
